import { Language } from './language.model';

export class StartupConfiguration {
  itemId: string;
  configurationId: string;
  language: Language;
  token: string;
}
